import { render, staticRenderFns } from "./trainerDashboard.vue?vue&type=template&id=35ac1222&scoped=true"
import script from "./trainerDashboard.vue?vue&type=script&lang=js"
export * from "./trainerDashboard.vue?vue&type=script&lang=js"
import style0 from "./trainerDashboard.vue?vue&type=style&index=0&id=35ac1222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac1222",
  null
  
)

export default component.exports